<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :label="item.title" :name="item.name" lazy :key="item.name">
        <!-- <component :is="item.name" prent-type="smallBag" :shopList="shopList" :forwarder="$attrs.forwarder"/> -->
      </el-tab-pane>
      <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" prentType="smallBag" :tableType="tableType"
        :countryList="$attrs.countryList" :shopList="shopList" ref="InterForm" />

      <InterBtnBox :finishBtn="tableType == 'builtBag'" :modify-btn="!tableType == 'shipped'"
        :pack-btn="false" :selectedRows="selectedRows" @overEmit="getDataSource"
        :down-btn="tableType === 'toBeProcessed'"
        :singleProduct="query.singleProduct" prentType="smallBag" :tableType="tableType" @refeash="getDataSource" />

      <InterList :tableType="tableType" @refeash="getDataSource" :layout="tableType == 'shipped' ? '' : 'logistics'"
        :dataSource="dataSource" :clean='clean' :singleProduct="query.singleProduct" @pageChange="pageChangeCall"
        @selectChange="selectChangeCall" prentType="smallBag" ref="interlist" :forwarder="$attrs.forwarder"
        :total="query.total"></InterList>
    </el-tabs>
  </div>
</template>

<script>

import ToBeProcessed from "@/views/outOfStock/internationalShipment/tabs/toBeProcessed";
import Picking from "@/views/outOfStock/internationalShipment/tabs/picking";
import BuildingBag from "@/views/outOfStock/internationalShipment/tabs/buildingBag";
import BuiltBag from "@/views/outOfStock/internationalShipment/tabs/builtBag";
import Shipped from "@/views/outOfStock/internationalShipment/tabs/shipped";
import InterForm from '@/views/outOfStock/internationalShipment/components/InterForm'
import InterList from "@/views/outOfStock/internationalShipment/components/InterList";
import InterBtnBox from "@/views/outOfStock/internationalShipment/components/InterBtnBox";
import { getShopList, shipTask, deliveryTaskPage } from "@/apis/outStock";
import { deliveryStatus, deliveryTypes, abandonFlagList } from "@/views/outOfStock/internationalShipment/tabs/index";
export default {
  title: '小包发货',
  name: "smallBagShip",
  components: {
    ToBeProcessed,
    Picking,
    BuildingBag,
    BuiltBag,
    Shipped,
    InterForm,
    InterBtnBox, InterList
  },
  // props: {
  //   forwarder: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  data() {
    return {
      activeName: ToBeProcessed.name,
      shopList: [],
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      clean: false,
      selectedRows: [],
      dataSource: [],
      tableType: 'toBeProcessed'
    }
  },
  created() {
    const that = this
    // try {
    //   getShopList({}).then(res => {
    //     console.log(res)
    //     const {data} = res
    //     that.shopList = data
    //   })
    // } catch (e) {
    //   console.log('获取店铺列表失败')
    //   that.shopList = [
    //     {customerShopName: 'king-shop', customerShopId: 1},
    //     {customerShopName: 'king-shop1', customerShopId: 2},
    //     {customerShopName: 'king-shop2', customerShopId: 3},
    //     {customerShopName: 'king-shop3', customerShopId: 4},
    //   ]
    // }
  },
  computed: {
    comList: function () {
      return [
        {name: 'waitUp', title:'待上架' },
        // 待处理
        ToBeProcessed, 
        // 拣货中
        Picking, 
        // 打包中
        BuildingBag, 
        // 打包完成
        BuiltBag, 
        // 已发货
        Shipped, 
        {name: 'abandoned', title: '已废弃'}, 
        {name: 'intercept', title: '已拦截'}]
    }
  },
  methods: {
    handleClick(e) {
      this.tableType = e.name
      this.queryHandler()
    },
    queryHandler: function (payload) {
      console.log(payload)
      console.log(this)
      this.query = {
        ...this.query,
        ...payload
      };
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    getDataSource: function () {
      // 获取列表数据
      this.selectedRows = [];
      const params = {
        ...this.query,
        pageNum: this.query.current,
        deliveryStatus: deliveryStatus[this.tableType],
        deliveryType: deliveryTypes["smallBag"],
        processingStatus: 2,
        abandonFlag: abandonFlagList[this.tableType],
        interceptFlag: this.tableType === 'intercept' ? 1 : 0
      };
      if(params.deliveryTaskCode && params.deliveryTaskCode.split(',').length){
        params.deliveryTaskCodeList = params.deliveryTaskCode.split(',')
        delete params.deliveryTaskCode
      }
      if(params.logisticsCodeStr && params.logisticsCodeStr.split(',').length){
        params.logisticsCodeList = params.logisticsCodeStr.split(',')
        delete params.logisticsCodeStr
      }
      this.clean = true;
      if(this.tableType === 'intercept') {
        params.processingStatus = null
      }
      deliveryTaskPage(params)
        .then((res) => {
          const {
            data: { total = 0, records = [] },
          } = res;
          records.forEach(item => {
            let text = ''
            if (item.channelNo && item.logisticsChannelDTOList) {
              item.logisticsChannelDTOList.forEach(item_son => {
                if (item_son.channelNo == item.channelNo) {
                  text = item_son.channelName
                }
              })
            }
            item.channelNo = text
            item.hasLogisticsCode = item.logisticsDetailList.length?item.logisticsDetailList.some(item=>item?item.logisticsCode:false):false
          })
          this.query.total = total;
          this.dataSource = records;
          // const {}
        })
        .finally((_) => {
          this.clean = false;
        });
    },
    getFormInfo() {
      return 123, this.$refs.InterForm.formInline
    }
  },
  provide() {
    return {
      getFormInfo: this.getFormInfo
    }
  },
}
</script>

<style scoped>

</style>